(($) => {
    'use strict';

    let button = document.getElementById('submit-video');
    if ($(button).length === 0) {
        return;
    }

    let fileInput = document.getElementById('file');
    let name = document.getElementById('name');
    let description = document.getElementById('description') ?? '';
    let _token = $('meta[name="csrf-token"]').attr('content');

    $(button).on('click', () => {

            if (!$('#form').valid()) {
                return false;
            }

            $(button).attr('disabled', 'disabled').find('.fa-spinner').removeClass('d-none');

            $.ajax({
                url: '/api/cloudflare/getdirectupload',
                type: 'POST',
                data: {
                    videoSize: parseInt(fileInput.files[0].size),
                    videoDuration: 200,
                    videoName: name.value,
                    videoDescription: description.value,
                    _token: _token
                },
                success: response => {
                    uploadToCloudflare(response.data);
                }
            })
            return false;
    });

    const uploadToCloudflare = (url) => {
        Swal.fire({
            title: 'Upload en cours ...',
            html: `<div class="progress m-3">
                        <div id="progress"
                            class="progress-bar"
                            role="progressbar"
                            aria-valuenow="0"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        ></div>
                    </div>`,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        let upload = new tus.Upload(fileInput.files[0], {
            uploadUrl: url,
            retryDelays: [0, 3000, 5000, 10000, 20000],
            onError: error => {
                console.error("Error: " + error);
                Swal.fire({
                    icon: 'error',
                    title: 'Upload failed',
                    text: error,
                    confirmButtonColor: "#3085d6",
                });

            },
            onSuccess: () => {
                window.location = $(button).attr('data-redirect-link');
            },
            onProgress: (bytesUploaded, bytesTotal) => {
                let progress = (bytesUploaded / bytesTotal * 100).toFixed();
                let bar = Swal.getHtmlContainer().querySelector('#progress');
                bar.setAttribute('aria-valuenow', progress);
                bar.style.width = bar.innerHTML = progress + '%';
            },
        });

        upload.findPreviousUploads().then(previousUploads => {
            if (previousUploads.length) {
                upload.resumeFromPreviousUpload(previousUploads[0]);
            }
            upload.start();
        })
    }

})($);
